import { MutableRefObject, RefObject, useEffect } from 'react';

export const useClickOutSide = ({
  open,
  onToggleList,
  fieldViewRef,
  listRef,
}: {
  open: boolean;
  onToggleList: () => void;
  fieldViewRef: RefObject<HTMLDivElement>;
  listRef: RefObject<HTMLUListElement>;
}) => {
  useEffect(() => {
    if (!open) return () => {};
    const handlerDocumentClick = (e: MouseEvent) => {
      const { target } = e;
      if (
        target instanceof Node &&
        fieldViewRef.current &&
        !fieldViewRef.current.contains(target) &&
        listRef.current &&
        !listRef.current.contains(target)
      ) {
        onToggleList();
      }
    };
    document.addEventListener('mousedown', handlerDocumentClick);
    return () => document.removeEventListener('mousedown', handlerDocumentClick);
  }, [open]);
};

export const useListScrollByKeyBoard = ({
  activeIndex,
  optionRefs,
  open,
}: {
  activeIndex: number | null;
  optionRefs: MutableRefObject<(HTMLLIElement | null)[]>;
  open: boolean;
}) => {
  useEffect(() => {
    if (!open) return;
    const el = optionRefs.current[activeIndex ?? 0];
    if (el && el.scrollIntoView) {
      el.scrollIntoView({ block: 'nearest' });
    }
  }, [activeIndex, open]);
};
